import React from 'react';
import novaImage from '../Nova_02.png';

const Nova02Image = () => <img style={{height: 180}} src={novaImage}></img>;

export default Nova02Image;
